import { DownloadIcon } from '@chakra-ui/icons';
import {
    Button,
    Flex,
    Heading,
    Image,
    Stack,
    Text,
    useBreakpointValue,
  } from '@chakra-ui/react';
import { TypeAnimation } from 'react-type-animation';
import profile from '../profile/Rutuvik Patil Photo.png';
import resume from '../profile/Rutuvik-Resume.pdf';
  
  export default function About() {

    // const handleClick=()=>{
    //   fetch("Rutuvik-Patil-Resume.pdf").then((res)=>{
    //     res.blob().then((blob)=>{
    //       const fileUrl = window.URL.createObjectURL(blob);
    //       let file = document.createElement("a");
    //       // file.target='_blank';
    //       file.href = fileUrl;
    //       file.download = "Rutuvik-Patil-Resume.pdf";
    //       file.click();
    //     });
    //     window.location.href=("https://drive.google.com/drive/folders/1kAk4OG9IAk7Ojc5k0tJ67CVHBa1Rpxi5?usp=sharing")
    //   })
    // }



    return (
      <div id='about' className='about section' style={{borderBottom:'1px solid gray', paddingBottom:'40px'}}>
        <Heading color={'text'} mb='20px'>About <strong style={{color:'#4FC3F7'}}>Me</strong></Heading>
      <Stack direction={{ base: 'column', md: 'row' }}>
        <Flex flex={1} align={'center'} justify={'center'}>
          <Image
          className='home-img'
            alt={'Profile Image'}
            objectFit={'cover'}
            rounded={'20%'}
            src={profile}
          />
        </Flex>
        <Flex p={8} flex={1} align={'center'} justify={'center'}>
          <Stack spacing={6} w={'full'} maxW={'lg'}>
            <Heading fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}>
              <Text
                as={'span'}
                position={'relative'}
                color='#D8D8D8'
                _after={{
                  content: "''",
                  width: 'full',
                  height: useBreakpointValue({ base: '20%', md: '30%' }),
                  position: 'absolute',
                  bottom: 1,
                  left: 0,
                  bg: '#4FC3F7',
                  zIndex: -1,
                }}>
                I'm a
              </Text>
              <br />{' '}
              <Text color={'#4FC3F7'} colorScheme='secondary' as={'span'}>
               <TypeAnimation sequence={['Full Stack Developer',1000,'Problem Solver',1000,'Web Developer',1000,'React Developer',1000]} speed={10} repeat={Infinity} deletionSpeed={40} />
              </Text>{' '}
            </Heading>
            <Text id="user-detail-intro" fontSize={{ base: 'md', lg: 'lg' }} color={'text'}>
            My name is <strong id='user-detail-name' style={{color:'#4FC3F7'}}>Rutuvik Patil</strong>, and I am an aspiring Full Stack Developer with a strong proficiency in React, HTML, JavaScript and CSS. With a passion for learning and problem-solving, I am always seeking out new challenges that will enable me to leverage and hone my skills.
            </Text>
            <Stack direction={{ base: 'column', md: 'row' }} spacing={4}>
              <Button
                id="resume-button-2"
                rounded={'full'}
                // onClick={handleClick}
                bg={'#4FC3F7'}
                color={'white'}
                _hover={{
                  bg: 'blue.500',
                }}>
               <a href={resume} download="Rutuvik-Resume.pdf" id='resume-link-2' target='_blank' onClick={()=>window.open("https://drive.google.com/file/d/1J_Xvq2-tQGlo9SmrRFGZIA00VvZnTno8/view?usp=sharing")}>My Resume  <DownloadIcon ml={'2px'}/></a>
              </Button>
            </Stack>
          </Stack>
        </Flex>
      </Stack>
      </div>
    );
  }